import React from 'react';

export function Label({ className = '', children, ...rest }) {
  return (
    <label
      className={`block text-sm font-medium text-foreground ${className}`}
      {...rest}
    >
      {children}
    </label>
  );
}

export default Label;
